import { createRedesignEntry } from "../redesign-page-entry";

/**
 * «Информация об оплате» (`/payment/details`) — reached from the footer's «Оплата» link.
 * Uses the same entry wrapper as `contacts-entry.tsx`.
 */
export default createRedesignEntry(() => import("./payment-details-page"), {
  testId: "rd-payment-details-loading",
  shell: { breadcrumbLeaf: { id: "page.footer.payment", defaultMessage: "Payment" } },
});
